import DashboardContainer from "./DashboardContainer";
import DashboardStore from "./DashboardStore";


export default DashboardStore(DashboardContainer);